<script lang="ts">
	import PageGrid from '$lib/storyblok/components/pageGrid.svelte';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		content: ISbStoryData<{
			headline: string | ISbRichtext;
			subheading: string | ISbRichtext;
			alignment: 'left' | 'center' | 'wide';
			color: 'brown' | 'green' | 'white';
			spacing: 'default' | 'compact';
		}>['content'];
	}

	let { content }: Props = $props();

	let spacingClasses = $derived(
		content.spacing === 'compact' ? 'mb-6 lg:mb-9 mt-6 lg:mt-8 2xl:mt-16' : ''
	);
</script>

<div use:editable={content} class={spacingClasses}>
	<PageGrid>
		<div
			class="col-span-full flex flex-col text-left lg:col-start-3 lg:col-end-11 lg:text-center"
			class:font-serif={content.color === 'green'}
		>
			{#if content.headline}
				<div
					class="lp-headline text-balance font-rhymes text-brown-1"
					class:text-brown-1={content.color === 'brown'}
					class:text-[#F8F4EB]={content.color === 'white'}
				>
					<SbRichtext text={content.headline} />
				</div>
			{/if}

			{#if content.subheading}
				<div
					class="mt-3 text-balance text-[16px]/[140%] text-brown-1 lg:text-[20px]"
					class:text-green-3={content.color === 'green'}
					class:text-brown-1={content.color === 'brown'}
					class:text-[#F8F4EB]={content.color === 'white'}
				>
					<SbRichtext text={content.subheading} />
				</div>
			{/if}
		</div>
	</PageGrid>
</div>

<style lang="scss">
	div.lp-headline {
		:global {
			h1 {
				line-height: 110%;
				font-size: 40px;
				letter-spacing: -0.32px;

				@media screen and (min-width: 1024px) {
					font-size: 56px;
					letter-spacing: -0.56px;
				}
			}

			h2,
			h3,
			h4,
			h5,
			h6,
			p {
				line-height: 108%;
				font-size: 40px;
				letter-spacing: -1.2px;

				@media screen and (min-width: 1024px) {
					font-size: 52px;
					letter-spacing: -0.48px;
				}
			}

			span {
				padding: 0 6px;
				border-radius: 4px;
			}
		}
	}
</style>
